export default {
    'ERROR-REFERRAL-USER': {
        'INVALID-EMAIL': {
            actionType: 'toast',
            message: {
                fr: "L'adresse e-mail fournie est invalide.",
                en: 'The provided email address is invalid.',
            },
        },
        'USER-ALREADY-EXIST': {
            actionType: 'custom',
        },
        'USER-ALREADY-REFERRED': {
            actionType: 'custom',
        },
        'NO-REFERRAL-CAMPAIGN': {
            actionType: 'toast',
            message: {
                fr: "Aucune campagne de référence n'est disponible.",
                en: 'No referral campaign is available.',
            },
        },
        'REFERRAL-CAMPAIGN-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "La campagne de référence est introuvable.",
                en: 'The referral campaign was not found.',
            },
        },
    },
    'ERROR-GET-ALL-REFERRALS': {
        'REFERRALS-NOT-FOUND': {
            actionType: 'toast',
            message: {
                fr: "Aucune référence trouvée.",
                en: 'No referrals found.',
            },
        },
    },
};
